export default __webpack_public_path__ + "static/media/ae.6d442d89.jpg";